// OIDC (Keycloak SSO) утилиты: PKCE + authorization endpoint
// Браузерный URL Keycloak — относительный путь /auth (проксируется nginx на 127.0.0.1:8090)

export const KC_AUTH_URL = '/auth/realms/terra/protocol/openid-connect/auth';
export const KC_CLIENT_ID = 'terra-sup';

function base64url(bytes) {
  return btoa(String.fromCharCode(...bytes))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

export function generatePkce() {
  const bytes = new Uint8Array(48);
  crypto.getRandomValues(bytes);
  return base64url(bytes);
}

export async function pkceChallenge(verifier) {
  const data = new TextEncoder().encode(verifier);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return base64url(new Uint8Array(digest));
}

export function redirectUri() {
  return `${window.location.origin}/login/callback`;
}

export async function startSsoLogin() {
  const verifier = generatePkce();
  const state = generatePkce();
  sessionStorage.setItem('oidc_verifier', verifier);
  sessionStorage.setItem('oidc_state', state);

  const params = new URLSearchParams({
    client_id: KC_CLIENT_ID,
    response_type: 'code',
    scope: 'openid profile email',
    redirect_uri: redirectUri(),
    state,
    code_challenge: await pkceChallenge(verifier),
    code_challenge_method: 'S256',
  });
  window.location.replace(`${KC_AUTH_URL}?${params.toString()}`);
}
